module.exports = __webpack_public_path__ + "media/assets/images/tour/5b_Tour_3-c95108c6883689272b3941e641b38021.png";